/**
 * A custom element that formats rte content for easier styling
 */
class RTEFormatter extends HTMLElement {
  connectedCallback() {
    this.querySelectorAll('table').forEach(this.#formatTable);

    if (this.closest('#header-group, .footer-content')) {
      this.querySelectorAll('a[href]').forEach(this.#formatExternalLink);
    }
  }

  /**
   * Formats a table for easier styling
   * @param {HTMLTableElement} table
   */
  #formatTable(table) {
    const wrapper = document.createElement('div');
    wrapper.classList.add('rte-table-wrapper');
    const parent = table.parentNode;
    if (parent) {
      parent.insertBefore(wrapper, table);
      wrapper.appendChild(table);
    }
  }

  /**
   * Opens external links in a new tab (header/footer only).
   * @param {HTMLAnchorElement} anchor
   */
  #formatExternalLink(anchor) {
    if (anchor.target === '_blank') return;

    const href = anchor.getAttribute('href');
    if (!href || href.startsWith('#') || href.startsWith('mailto:') || href.startsWith('tel:')) {
      return;
    }

    if (!this.#isExternalUrl(href)) return;

    anchor.target = '_blank';
    anchor.rel = 'noopener noreferrer';
  }

  /**
   * @param {string} url
   * @returns {boolean}
   */
  #isExternalUrl(url) {
    const urlDowncase = url.toLowerCase();

    if (
      urlDowncase.includes('homedesignshops.nl') ||
      urlDowncase.includes('homedesignshops.com')
    ) {
      return true;
    }

    if (
      !url.includes('http://') &&
      !url.includes('https://') &&
      !url.includes('//')
    ) {
      return false;
    }

    try {
      const linkHost = new URL(url, window.location.origin).hostname
        .toLowerCase()
        .replace(/^www\./, '');
      const currentHost = window.location.hostname.toLowerCase().replace(/^www\./, '');

      return linkHost !== currentHost && linkHost !== '';
    } catch {
      return false;
    }
  }
}

if (!customElements.get('rte-formatter')) {
  customElements.define('rte-formatter', RTEFormatter);
}
